/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Paper, Tab, Tabs } from '@mui/material';
import styles from './styles/view-details-styles.module.css';
import { useViewSuspensionDetails } from './hooks/useViewSuspensionDetails';

export const ViewDetails = () => {
	const { currentTab, matches, tabItems, setCurrentTab, getComponent } =
		useViewSuspensionDetails();

	return (
		<>
			<Tabs
				value={currentTab}
				variant="scrollable"
				onChange={(_, value) => {
					setCurrentTab(value);
				}}
				TabIndicatorProps={{
					style: { background: 'var(--color-primary-main)' },
				}}
				sx={{
					'& button.Mui-selected': {
						color: 'var(--color-primary-main)',
					},
					width: '100%',
				}}
				orientation={matches ? 'vertical' : 'horizontal'}
			>
				{(tabItems || []).map((element, index: number) => {
					return (
						<Tab
							key={index}
							className={styles.tabsStyle}
							label={element.label}
						/>
					);
				})}
			</Tabs>
			<Paper>
				<Box padding={3}>{getComponent()}</Box>
			</Paper>
		</>
	);
};
